import {Component} from '@angular/core';
import {Platform} from 'ionic-angular';

import {HomePage} from '../pages/home/home';
import {AppState} from './app.global';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any = HomePage;

  themes: Array<string> = ['theme-default', 'theme-sura']

  constructor(platform: Platform, public global: AppState) {
    this.global.set('theme', 'theme-default')
    this.global.set('logo', 'logo-white.png')

    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts